import { Grid } from '@change/ds-layout';

export function PageHeader(): JSX.Element {
	// TODO: 68px height is not final. Adjust if needed when hifi designs are ready
	return (
		<div className="bg-background-base border-stroke-weaker h-[68px] w-full border-b">
			<Grid>
				<div>Header</div>
			</Grid>
		</div>
	);
}
